import { createContext, useContext, useState } from 'react';
import es from './es';
import en from './en';

const LANGS = { es, en };
const DEFAULT_LANG = 'es';

const I18nContext = createContext({ t: (key) => key, lang: DEFAULT_LANG, setLang: () => {} });

/**
 * Get nested value from object by dot-separated key
 * e.g. t('status.requested') → 'Solicitada'
 */
function getNestedValue(obj, path) {
  return path.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : path), obj);
}

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem('mc_lang') || DEFAULT_LANG; } catch { return DEFAULT_LANG; }
  });

  const changeLang = (newLang) => {
    if (LANGS[newLang]) {
      setLang(newLang);
      try { localStorage.setItem('mc_lang', newLang); } catch {}
    }
  };

  const t = (key, params) => {
    let val = getNestedValue(LANGS[lang] || LANGS[DEFAULT_LANG], key);
    if (typeof val !== 'string') return key;
    // Replace {n} placeholders
    if (params) {
      for (const [k, v] of Object.entries(params)) {
        val = val.replace(`{${k}}`, v);
      }
    }
    return val;
  };

  return (
    <I18nContext.Provider value={{ t, lang, setLang: changeLang, availableLangs: Object.keys(LANGS) }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}

export { LANGS };
